import ExternalRedirect from 'components/externalRedirect';
import PropTypes from 'prop-types';
import React from 'react';
import TitleManager from 'swa-components-core/titleManager';
import { toRedirect } from '../../utils/redirectUtils';

const propTypes = {
    session: PropTypes.shape({
        scope: PropTypes.string.isRequired
    })
};

export const HomePage = (props) => {
    const { session } = props;
    const origin = window.location.origin;
    const redirect = toRedirect(session.scope.split(' '));

    return (
        <>
            <TitleManager />
            {redirect && <ExternalRedirect to={`${origin}/${redirect}`} />}
        </>
    );
};

HomePage.propTypes = propTypes;

export default HomePage;
